import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import useUser from "../../Hooks/useUser";
import LoginValidation from "../../Utils/LoginValidation";
import imagen from "../../../assets/images/Ingeniobackground.jpg";
import imagenPoderosa from "../../../assets/images/poderosa/poderosaImagen-min.jpg";
import Bowser from "bowser";
import MicrosoftLogin from "react-microsoft-login";
import microsoftIcon from "../../../assets/images/Microsoft.png"; // Importa el icono de Microsoft
import { CLAIM_CODCUSTOMER, getInfoToken } from "../../Utils/RoleHelper";
import { jwtDecode } from "jwt-decode";

export default function Login(props) {
  const [exp, setExp] = useState(0);
  const [isLoginInProgress, setIsLoginInProgress] = useState(false);
  const [verLoading, setVerLoading] = useState(false);

  const { login, loginMicrosoft, isLoginLoading, hasLoginError, token } =
    useUser();

  const [showPassword, setshowPassword] = useState(false);

  // useEffect(() => {
  //   if (exp !== 0) {
  //     // Redirecciona o realiza la acción que necesitas cuando exp se actualiza.
  //     //_handleLoginMicrosoft({ appid: "", exp, unique_name: "" });
  //     loginMicrosoft({ appid: "", exp, unique_name: "" });
  //   }
  // }, [exp]);

  var codCustomer = getInfoToken(token, CLAIM_CODCUSTOMER);
  const bowser = Bowser.getParser(window.navigator.userAgent);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      userAgent: bowser.getBrowser().name,
    },
    validationSchema: LoginValidation,
    onSubmit: (values) => {
      login(values);
    },
  });

  const clickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const token = params.get("id_token");

    if (token) {
      //setIdToken(token);
      // Optionally, store the token in local storage
      //localStorage.setItem('id_token', token);
      console.log("Token: ", token);
      const result = jwtDecode(token);
      console.log("decodedClaims: ", result);
      let tokenReceived = {
        appid: result.aud,
        exp: result.exp,
        unique_name: result.preferred_username,
        userAgent: bowser.getBrowser().name,
      };

      if (exp != tokenReceived.exp) {
        setExp(tokenReceived.exp);
        loginMicrosoft(tokenReceived);
        //_handleLoginMicrosoft(tokenReceived);
      }
      setExp(tokenReceived.exp);
    }
  }, []);

  const handleLoginClick = () => {
    if (!isLoginInProgress) {
      setIsLoginInProgress(true);
      // Trigger the login process
    }
  };

  /* const _handleLoginMicrosoft = (token) => {
    setIsLoginInProgress(false);
    setVerLoading(true);
    AuthenticationService.loginMicrosoft(token)
      .then((response) => {
        if (response.status == 200) {
          let res = JSON.parse(response.request.response);
          if (res.succeeded) {
            setExcepcion(null);
            if (res.accessToken != undefined && res.accessToken !== "") {
              signin(
                {
                  username: token.unique_name,
                  token: res.accessToken,
                },
                () => navigate("/", { replace: true })
              );
            }
          } else {
            setExcepcion(res.exception);
          }
        }
        setVerLoading(false);
      })
      .catch((e) => {
        console.log(e);
        if (e != undefined) {
          setExcepcion(e.message);
        }
        setVerLoading(false);
      });
  }; */

  const authHandler = async (err, data, msal) => {
    setIsLoginInProgress(false);
    if (data) {
      if (data.idTokenClaims) {
        let tokenReceived = {
          appid: data.idTokenClaims.aud,
          exp: data.idTokenClaims.exp,
          unique_name: data.idTokenClaims.preferred_username,
          userAgent: bowser.getBrowser().name,
        };

        console.log("esta es la respuesta", tokenReceived);
        if (exp !== tokenReceived.exp) {
          loginMicrosoft(tokenReceived, msal);
                     //_handleLoginMicrosoft(tokenReceived);
        }
        setExp(tokenReceived.exp);
      }
    }
    console.log("esta es la error", err);
  };
  const url = true;
  const dominio = window.location.hostname;

  const PanAmerica = (window.location.hostname == 'ingenio-panamericansilver.idslatam.com' ||   window.location.hostname =='ingenioqas-panamericansilver.idslatam.com')  ? true : false ;

  return (
    <>
      {!PanAmerica && (
        <div
          className="pt-0"
          style={{
            backgroundImage: `url(${
              dominio == "ingenioqas-poderosa.idslatam.com" ||
              dominio == "ingenio-poderosa.idslatam.com"   
                ? imagenPoderosa
                : imagen
            })`,
            height: "100vh",
            backgroundSize: "cover",
            backgroundPosition:"center"
          }}
        >
          {dominio == "ingenioqas-poderosa.idslatam.com" ||
          (dominio == "ingenio-poderosa.idslatam.com")  ? (
            <div className="d-flex align-items-center auth">
              <div className="row w-100 mx-5   loginContainerPoderosaBox" style={{ height: "100%" }}>
                <div
                  className="loginContainerPoderosa"
                  style={{ marginLeft: "auto", }}
                >
                  <div
                    className="  text-left d-flex"
                    style={{
                      height: "100%",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                      paddingLeft: "2rem",
                      paddingRight: "2rem",
                      background: "rgba(255, 255, 255, 0.7)",
                    }}
                  >
                    <div className="text-center" style={{ width: "100%" }}>
                      <img
                        src={require("../../../assets/images/poderosa/loginPoderosaLogo.png")}
                        style={{ height: 110, width: "100%" }}
                        alt="alt"
                      />
                    </div>
                    <h4 className="text-center" style={{ color: "#9a9b99" }}>
                      INICIAR SESIÓN
                    </h4>

                    <div className="mt-3 " style={{ width: "100%" }}>
                      <MicrosoftLogin
                        clientId={"214edca4-6888-425c-aad8-6b8ed9494f04"}
                        // clientId={cuentaId}
                        authCallback={(err, data) => {
                          if (!isLoginInProgress) {
                            authHandler(err, data, null);
                          }
                        }}
                        // authCallback={authHandler}
                        withUserData={false}
                        // children={""}
                        // redirectUri="https://teseo.idslatam.com/core/login"
                        forceRedirectStrategy={true}
                        useLocalStorageCache={true}
                        // redirectUri={INITIAL_URL}
                      >
                        <button
                          onClick={handleLoginClick}
                          type="submit"
                          className="btn btn-block   btn-lg font-weight-medium auth-form-btn"
                          style={{
                            background: "#004f94",
                            color: "#fff",
                            width: "100%",
                          }}
                        >
                          <img
                            src={microsoftIcon} // Ruta del icono de Microsoft
                            alt="Microsoft Icon"
                            style={{
                              width: "35px",
                              margin: "0px",
                              padding: "0px 10px",
                            }} // Estilos del icono
                          />
                          Ingresar con tu cuenta de Microsoft{" "}
                        </button>
                      </MicrosoftLogin>
                    </div>
                    <Form
                      className="pt-3 mt-4 "
                      style={{ width: "100%" }}
                      onSubmit={formik.handleSubmit}
                    >
                      <div class="px-0">
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <i class="fa-solid fa-envelope"></i>
                            </div>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            id="email"
                            placeholder="Email"
                            {...formik.getFieldProps("email")}
                          />
                        </div>
                        {formik.touched.email && formik.errors.email ? (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: ".8rem" }}
                          >
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </div>

                      {isLoginLoading && isLoginLoading ? (
                        <div
                          className="col-md-4 col-sm-6 bg-transparent border-0 position-absolute ml-5"
                          style={{ zIndex: 3 }}
                        >
                          <div className="circle-loader"></div>
                        </div>
                      ) : (
                        " "
                      )}

                      <div class="px-0 mt-2">
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <i class="fa-solid fa-key"></i>
                            </div>
                          </div>
                          <input
                            type={showPassword ? "text" : "password"}
                            class="form-control"
                            id="password"
                            placeholder="Contraseña"
                            {...formik.getFieldProps("password")}
                          />
                        </div>
                        {formik.touched.password && formik.errors.password ? (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: ".8rem" }}
                          >
                            {formik.errors.password}
                          </div>
                        ) : null}

                        <div class="px-0">
                          <div class="form-check mb-2">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="autoSizingCheck"
                              onChange={clickShowPassword}
                            />
                            <label
                              class="form-check-label"
                              for="autoSizingCheck"
                            >
                              Mostrar contraseña{" "}
                            </label>
                          </div>
                        </div>
                      </div>

                      {hasLoginError && hasLoginError ? (
                        <strong className="text-danger text-center">
                          Email y/o Contraseña son incorrectos
                        </strong>
                      ) : (
                        " "
                      )}
                      <div className="mt-3">
                        <button
                          type="submit"
                          className="btn btn-block d-flex    btn-lg font-weight-medium  "
                          style={{
                            backgroundColor: "rgb(100, 179, 100)",
                            color: "#fff",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: ".5rem",
                          }}
                        >
                          Ingresar <i class="fa-solid fa-arrow-right"></i>{" "}
                        </button>
                        <div className="my-2 d-flex justify-content-center align-items-center">
                          <Link
                            className="auth-link text-black"
                            to="/user-pages/lockscreen"
                            style={{ color: "#004f94" }}
                          >
                            Olvidé mi contraseña
                          </Link>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center auth">
              <div className="row w-100 mx-5 login-gold" >
                <div
                  className="col-lg-4 mr-xl-5 mr-lg-5 login-box"
                  style={{ marginLeft: "auto" }}
                >
                  <h4 className="card-description mb-1 text-center">
                    Aquí es donde grandes ideas y
                  </h4>
                  <h4 className="card-description mb-3 text-center">
                    proyectos comienzan:
                  </h4>
                  <div
                    className="auth-form-light text-left py-5 px-4 px-sm-5"
                    style={{ borderRadius: "15px" }}
                  >
                    <div className="text-center">
                      <img
                        src={require("../../../assets/images/Ingenio.png")}
                        style={{ height: 110, width: 290 }}
                        alt="alt"
                      />
                    </div>
                    <h4 className="text-center">Inicio de Sesión</h4>
                    <Form className="pt-3" onSubmit={formik.handleSubmit}>
                      <label className="card-description mb-1">Usuario</label>
                      <Form.Group className="search-field">
                        <Form.Control
                          type="text"
                          size="lg"
                          className="h-auto"
                          placeholder="Email"
                          id="email"
                          {...formik.getFieldProps("email")}
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <div className="text-danger mt-2">
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </Form.Group>
                      {isLoginLoading && isLoginLoading ? (
                        <div
                          className="col-md-4 col-sm-6 bg-transparent border-0 position-absolute ml-5"
                          style={{ zIndex: 3 }}
                        >
                          <div className="circle-loader"></div>
                        </div>
                      ) : (
                        " "
                      )}
                      <label className="card-description mb-1">
                        Contraseña
                      </label>
                      <Form.Group className="search-field">
                        <Form.Control
                          size="lg"
                          className="h-auto"
                          type="password"
                          placeholder="Contraseña"
                          id="password"
                          {...formik.getFieldProps("password")}
                        />
                        {formik.touched.password && formik.errors.password ? (
                          <div className="text-danger mt-2">
                            {formik.errors.password}
                          </div>
                        ) : null}
                      </Form.Group>
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <Link
                          className="auth-link text-black"
                          to="/user-pages/lockscreen"
                        >
                          ¿Has olvidado la contraseña?
                        </Link>
                      </div>
                      {hasLoginError && hasLoginError ? (
                        <strong className="text-danger text-center">
                          Email y/o Contraseña son incorrectos
                        </strong>
                      ) : (
                        " "
                      )}
                      <div className="mt-3">
                        <button
                          type="submit"
                          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        >
                          Inicio de Sesión
                        </button>
                      </div>
                    </Form>

                    <div className="mt-3">
                      <MicrosoftLogin
                        clientId="214edca4-6888-425c-aad8-6b8ed9494f04"
                        withUserData={false}
                        authCallback={authHandler}
                      >
                        <button
                          type="submit"
                          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        >
                          <img
                            src={microsoftIcon} // Ruta del icono de Microsoft
                            alt="Microsoft Icon"
                            style={{
                              width: "45px",
                              margin: "0px",
                              padding: "0px 10px",
                            }} // Estilos del icono
                          />
                          Inicio de Sesión Con Microsoft
                        </button>
                      </MicrosoftLogin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {PanAmerica && (
        <div
          style={{
            height: "100vh",
            display: "flex",

             position: "relative",
            background: "#e9e9e9",
          }}
        >


<div className="imgContainer">

<img
              src={require("../../../assets/images/panAmerica/left.png")}
              style={{ objectFit: "fill", width: "100%", height: "100%" }}
              alt="alt"
            />

</div>


<div className="imgContainer">

<img
              src={require("../../../assets/images/panAmerica/right.png")}
              style={{ objectFit: "fill", width: "100%", height: "100%" }}
              alt="alt"
            />

</div>

         
            <img
              src={require("../../../assets/images/panAmerica/Logo.png")}
              style={{
                objectFit: "inherit",
                width: "13%",
                height: 'auto',
                position: "absolute",
                top: "1%",
                left:'1%',
                zIndex: "10",
               }}
              alt="alt"
              className="logoAmmerica"
             />

        

            

          <div class="headerAmerica">
            Aquí empiezan a hacerse realidad las grandes ideas y proyectos en
            PAS.
          </div>
 
          <div className="d-flex align-items-center auth loginAmerica">
            <div className=" w-100 mx-5 login-container">
              <div
                className="col-lg-4    login-box "
               >
                <div
                  className="auth-form-light text-left   px-4 px-sm-5 login-PanAM "
                  style={{
                    borderRadius: "15px",
                    paddingTop: "4rem",
                    paddingBottom: "4rem",
                  }}
                >
                  <div className="text-center">
                    <img
                      src={require("../../../assets/images/Ingenio.png")}
                      style={{ height: 110, width: 290 }}
                      alt="alt"
                    />
                  </div>
                  <h4 className="text-center">Inicio de Sesión</h4>
                  <Form className="pt-3" onSubmit={formik.handleSubmit}>
                    <label className="card-description mb-1">Usuario</label>
                    <Form.Group className="search-field">
                      <Form.Control
                        type="text"
                        size="lg"
                        className="h-auto"
                        placeholder="Email"
                        id="email"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="text-danger mt-2">
                          {formik.errors.email}
                        </div>
                      ) : null}
                    </Form.Group>
                    {isLoginLoading && isLoginLoading ? (
                      <div
                        className="col-md-4 col-sm-6 bg-transparent border-0 position-absolute ml-5"
                        style={{ zIndex: 3 }}
                      >
                        <div className="circle-loader"></div>
                      </div>
                    ) : (
                      " "
                    )}
                    <label className="card-description mb-1">Contraseña</label>
                    <Form.Group className="search-field">
                      <Form.Control
                        size="lg"
                        className="h-auto"
                        type="password"
                        placeholder="Contraseña"
                        id="password"
                        {...formik.getFieldProps("password")}
                      />
                      {formik.touched.password && formik.errors.password ? (
                        <div className="text-danger mt-2">
                          {formik.errors.password}
                        </div>
                      ) : null}
                    </Form.Group>
                    <div className="my-2 d-flex justify-content-between align-items-center">
                      <Link
                        className="auth-link text-black"
                        to="/user-pages/lockscreen"
                      >
                        ¿Has olvidado la contraseña?
                      </Link>
                    </div>
                    {hasLoginError && hasLoginError ? (
                      <strong className="text-danger text-center">
                        Email y/o Contraseña son incorrectos
                      </strong>
                    ) : (
                      " "
                    )}
                    <div className="mt-3">
                      <button
                        type="submit"
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      >
                        Inicio de Sesión
                      </button>
                    </div>
                  </Form>

                  <div className="mt-3">
                    <MicrosoftLogin
                      clientId="214edca4-6888-425c-aad8-6b8ed9494f04"
                      withUserData={false}
                      authCallback={authHandler}
                    >
                      <button
                        type="submit"
                        className="btn btn-block btn-primary  font-weight-medium auth-form-btn"
                      >
                        <img
                          src={microsoftIcon} // Ruta del icono de Microsoft
                          alt="Microsoft Icon"
                          style={{
                            width: "45px",
                            margin: "0px",
                            padding: "0px 10px",
                          }} // Estilos del icono
                        />
                        Inicio de Sesión Con Microsoft
                      </button>
                    </MicrosoftLogin>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="overlayAmerica"></div> */}
                {/* <div className="overlayAmerica"></div> */}
        </div>
      )}
    </>
  );
}
